import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';


export default class BreakContingousSpace extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Break Contingous Space
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/break/spaces"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/BreakContingousSpace.js